import React, { useState } from 'react';

// Commented the below code because of it only poping up once.

// function CommonModal(props) {

//     const [popupStatus, setPopupStatus] = useState(true);

//     const togglePopUpClose = () => {
//         setPopupStatus(false)
//     }

//     return (
//         <div className={`popUpModalBackground popUpmodalShowing-${popupStatus}`}>
//             {
//                 (props.msgstatus === 1) ?
//                     <div>
//                         <div className="popUpModal-success">
//                             <img className="popUpModal-successimg" src={require('../../images/success.png')} />
//                         </div>
//                         <div className="popUpModal-Content">
//                             {props.message}
//                             <div className="popUpModal-submitOutter">
//                                 <div className="popUpModal-submitInner" onClick={() => togglePopUpClose()}>close</div>
//                             </div>
//                         </div>
//                     </div>
//                     :
//                     <div>
//                         <div className="popUpModal-success">
//                             <img className="popUpModal-successimg" src={require('../../images/warning.png')} />
//                         </div>
//                         <div className="popUpModal-Content">
//                             {props.message}
//                             <div className="popUpModal-submitOutter">
//                                 <div className="popUpModal-submitInner" onClick={() => togglePopUpClose()}>close</div>
//                             </div>
//                         </div>
//                     </div>
//             }
//         </div>
//     );

// }


function CommonModal(props) {

    const [popupStatus, setPopupStatus] = useState(false);
    const togglePopUpClose = () => {
        setPopupStatus(false)
    }

    return (
        <div className={`popUpModalBackground popUpmodalShowing-${props.popupstatus}`}>
            {
                (props.msgstatus === 1) ?
                    <div>
                        <div className="popUpModal-success">
                            <img className="popUpModal-successimg" src={require('../../images/success.png')} />
                        </div>
                        <div className="popUpModal-Content">
                            {props.message}
                            <div className="popUpModal-submitOutter">
                                <div className="popUpModal-submitInner" onClick={() => props.setpopup(false)}>close</div>
                            </div>
                        </div>
                    </div>
                    :
                    <div>
                        <div className="popUpModal-success">
                            <img className="popUpModal-successimg" src={require('../../images/warning.png')} />
                        </div>
                        <div className="popUpModal-Content">
                            {props.message}
                            <div className="popUpModal-submitOutter">
                                <div className="popUpModal-submitInner" onClick={() => props.setpopup(false)}>close</div>
                            </div>
                        </div>
                    </div>
            }
        </div>
    );

}

export default CommonModal;